// extracted by mini-css-extract-plugin
export default {"title":"style_title__52vPo","wrapper":"style_wrapper__Y5k4h"};